// extracted by mini-css-extract-plugin
export default {"abrir":"AbrirCaja_abrir__Ekrkl","content":"AbrirCaja_content__QbGxa","input":"AbrirCaja_input__Vnepf","form":"AbrirCaja_form__QbzwB","actions":"AbrirCaja_actions__bojrO"};